export default __webpack_public_path__ + "static/media/doctor.07d64672.jpg";